// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";

import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/styles.css";
import "./assets/css/gin.css";

import ProvideAppContext from "./components/AppContext";
import ErrorMessage from "./components/ErrorMessage";
import ProtectedRoute from "./components/ProtectedRoute";
import Grilla from "./views/Grilla/Grilla";
import Organigrama from "./views/Organigrama/Organigrama";
// import Organica from "./views/Organica/Organica";
import Establecimientos from "./views/Establecimientos/Establecimientos";
import Login from "./views/Login/Login";
import Admin from "./views/Admin/Admin";
import Solicitudes from "./views/Solicitudes/Solicitudes";
import Usuario from "./views/Usuario/Usuario";
import { LoadingProvider } from "./components/LoadingContext";

// <AppPropsSnippet>
type AppProps = {
  pca: IPublicClientApplication;
};
// </AppPropsSnippet>

export default function App({ pca }: AppProps): JSX.Element {
  return (
    <MsalProvider instance={pca}>
      <Router>
        <ProvideAppContext>
          <LoadingProvider>
            <ErrorMessage />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<Grilla />} />
                {/* <Route path="/organica" element={<Organica />} /> */}
                <Route path="/organigrama" element={<Organigrama />} />
                <Route path="/establecimientos" element={<Establecimientos />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/solicitudes" element={<Solicitudes />} />
                <Route path="/usuario" element={<Usuario />} />
              </Route>
            </Routes>
          </LoadingProvider>
        </ProvideAppContext>
      </Router>
    </MsalProvider>
  );
}
